import type { FrontendPlugin } from "@backstage/frontend-plugin-api";
import { createFrontendPlugin } from "@backstage/frontend-plugin-api";

import { githubApi } from "./apis";
import { githubReleasesCard } from "./entityCards";

const githubPlugin: FrontendPlugin = createFrontendPlugin({
    pluginId: "github",
    extensions: [githubApi, githubReleasesCard],
});

export default githubPlugin;
